import React from 'react'
import system from 'system-components'
import { Icon } from 'components'

const A = system(
  {
    is: 'a',
  },
  'space',
  'color'
)

A.displayName = 'A'

const externalLinkBeginning = ['http://', 'https://']

export default ({ href, target, children, ...rest }) => {
  const isExternal = externalLinkBeginning.some(subStr => href.startsWith(subStr))
  return (
    <A href={href} target={target} rel={target === '_blank' ? 'noopener' : undefined} {...rest}>
      {children}
      { isExternal &&
        <Icon mb={1} name="external" size="0.6em" style={{ verticalAlign: 'middle' }} />}
    </A>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/A.js